'use client';

import { FacetsViewModel } from '@/types/api';
import { isPriceFacetViewModel } from '@/types/api-helpers';
import { toNumberCommas } from '@/utils/string-helpers';
import { FilterItemType } from './types';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { EasyAccess } from '../tag';
interface Props {
  item: FilterItemType;
  onClick: (item: FilterItemType, mainFacetKey: keyof FacetsViewModel, info?: string) => void;
  mainFacetKey: keyof FacetsViewModel;
}
export function SelectedFacet({
  item,
  onClick,
  mainFacetKey
}: Props) {
  const {
    isMobile
  } = useMobileDetect();
  const isPriceFacet = isPriceFacetViewModel(item);
  const toRender = isPriceFacet ? item.selectedFromPrice || item.selectedToPrice : true;
  const handleClick = (info?: string) => {
    if (typeof info === 'string') {
      onClick(item, mainFacetKey, info);
    } else {
      onClick(item, mainFacetKey);
    }
  };
  if (!toRender) return null;
  const size = isMobile ? 'medium' : 'large';

  // eslint-disable-next-line no-nested-ternary
  return isPriceFacet ? <>
            {!!item.selectedFromPrice && <EasyAccess onClick={() => handleClick('selectedFromPrice')} size={size}>
                    از {toNumberCommas(item.selectedFromPrice)} تومان
                </EasyAccess>}
            {!!item.selectedToPrice && <EasyAccess onClick={() => handleClick('selectedToPrice')} size={size}>
                    تا {toNumberCommas(item.selectedToPrice)} تومان
                </EasyAccess>}
        </> : item ? <EasyAccess onClick={() => handleClick()} size={size}>
            {item.displayNameFa || item.displayNameEn}
        </EasyAccess> : null;
}